import { Box } from '@mui/material';
import { useI18n } from '../../../i18';
import style from './index.module.scss';

const InactiveLabel = () => {
  const { t } = useI18n();
  return <Box className={style.root}>{t('inactive')}</Box>;
};

export default InactiveLabel;
